'use es6';

import { createSelector } from 'reselect';
import formatName from 'I18n/utils/formatName';

var getGates = function getGates(state) {
  return state.auth.allGates;
};

export var getPortal = function getPortal(state) {
  return state.auth.portal;
};

var getUser = function getUser(state) {
  return state.auth.user;
};

var getPortalScopes = createSelector([getPortal], function (portal) {
  return portal.scopes || [];
});
var getHasPortalScope = createSelector([getPortalScopes], function (portalScopes) {
  return function (scope) {
    return portalScopes.includes(scope);
  };
});
var getUserScopes = createSelector([getUser], function (user) {
  return user.scopes || [];
});
var getHasUserScope = createSelector([getUserScopes], function (userScopes) {
  return function (scope) {
    return userScopes.includes(scope);
  };
});
export var getIsUngated = createSelector([getGates], function (gates) {
  return function (gate) {
    return gates.includes(gate);
  };
});
export var getCurrentUserEmail = createSelector([getUser], function (user) {
  return user.email;
});
export var getCurrentUserId = createSelector([getUser], function (user) {
  return user.user_id;
});
export var getCurrentUserFullName = createSelector([getUser], function (user) {
  return formatName({
    firstName: user.first_name,
    lastName: user.last_name
  });
});
export var getIsCustomer = createSelector([getPortal], function (portal) {
  return !!portal.portal_id;
});
export var getHasInstallAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('marketplace-asset-access');
});
export var getHasContentAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('content-access');
});
export var getHasCreatePageTemplateInstallPromptAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('create-page-template-install-prompt-access');
});
export var getIsTrialPortal = createSelector([getPortal], function (portal) {
  return typeof portal === 'object' && !!portal.trial;
});
export var getHasCreateLandingPageAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('landingpages-write');
});
export var getHasCreateSitePageAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('pages-write');
});
export var getHasSitePagesAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('sitepages-access');
});
export var getHasCreateEmailAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('email-write');
});
export var getHasEmailAccess = createSelector([getHasUserScope], function (hasScope) {
  return hasScope('email-access');
});
export var getHasRequiredEmailSubscription = createSelector([getHasPortalScope], function (hasPortalScope) {
  return hasPortalScope('email-full-editing');
});
export var getHasRequiredMarketingHubSubscription = createSelector([getHasPortalScope], function (hasPortalScope) {
  return hasPortalScope('global-content-write-access');
});
export var getIsUngatedForPaginatePurchases = createSelector([getIsUngated], function (isUngated) {
  return isUngated('AssetMarketplace:paginate-purchases');
});